import { USER_PREFERENCE_VALUE_TYPE, UserPreference } from '@/api/model';

import { BOOLEAN_TOGGLE_OPTIONS } from './preferences.constant';

function getHelpText(
  helpTextMap: Record<string, string> | undefined,
  key: string,
): string | undefined {
  const value = helpTextMap?.[key];

  return typeof value === 'string' ? value : undefined;
}

export function getRadioOptions(preference: UserPreference) {
  const helpTextMap = preference.uiConfig?.helpText;

  if (preference.options?.length && preference.valueType === USER_PREFERENCE_VALUE_TYPE.ENUM) {
    return [...preference.options]
      .sort((a, b) => a.sortOrder - b.sortOrder)
      .map((option) => ({
        label: `FCT.REPORTING.HEADER.PREFERENCES.SETTING.${option.name.toUpperCase()}`,
        tooltip: getHelpText(helpTextMap, option.value),
        value: option.value,
      }));
  }

  return BOOLEAN_TOGGLE_OPTIONS.map((option) => ({
    ...option,
    tooltip: getHelpText(helpTextMap, option.value),
  }));
}

export function getRadioValue(
  preference: UserPreference,
  rawValue: undefined | UserPreference['currentValue'],
): string {
  if (preference.valueType === USER_PREFERENCE_VALUE_TYPE.BOOLEAN) {
    return rawValue === true ? 'true' : 'false';
  }

  return String(rawValue ?? '');
}
